module.exports = __webpack_public_path__ + "static/img/new_hosting_active.30d1470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_hosting_active.png
// module id = 5Lz6
// module chunks = 101